import { __rest } from "tslib";
import * as React from 'react';
import { ActionButtonWrapper, JSXContent, StyledInlineAlert, } from './InlineAlert.styled';
import { Icon } from '../icon';
import { Button } from '../..';
import { iconPropsSelect } from './styles';
export const InlineAlert = (_a) => {
    var { variant, heading, content, jsxContent, actionButton } = _a, props = __rest(_a, ["variant", "heading", "content", "jsxContent", "actionButton"]);
    const actionButtonVariant = variant === 'informative' ? 'primary' : variant;
    const AlertContentWithHeading = () => {
        return (React.createElement("div", null,
            React.createElement("div", { style: { display: 'flex', flexDirection: 'row' } },
                React.createElement("span", { style: { marginRight: '0.5rem' } },
                    React.createElement(Icon, Object.assign({}, iconPropsSelect(variant)))),
                React.createElement("h6", null, heading)),
            React.createElement("div", { style: { marginLeft: '2rem' } },
                content && React.createElement("p", null, content),
                React.createElement(JSXContent, null, jsxContent && jsxContent))));
    };
    const AlertContentWithoutHeading = () => {
        return (React.createElement("div", null,
            React.createElement("div", { style: { display: 'flex', flexDirection: 'row' } },
                React.createElement("span", { style: { marginRight: '0.5rem' } },
                    React.createElement(Icon, Object.assign({}, iconPropsSelect(variant)))),
                content && React.createElement("p", null, content),
                React.createElement(JSXContent, null, jsxContent && jsxContent))));
    };
    return (React.createElement(StyledInlineAlert, Object.assign({ variant: variant }, props),
        heading ? (React.createElement(AlertContentWithHeading, null)) : (React.createElement(AlertContentWithoutHeading, null)),
        actionButton && (React.createElement(ActionButtonWrapper, null,
            React.createElement(Button, Object.assign({}, actionButton, { "aria-label": "action button", variant: actionButtonVariant, fill: "light", size: "small" }))))));
};
//# sourceMappingURL=InlineAlert.js.map